import { TweenLite } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const jumptoNavLinks = document.querySelectorAll('a.jumpto-sidebar-link');
  const jumptoSections = document.querySelectorAll('.sectionAnchor');

  // Make sure we have some jump to nav links.
  if (jumptoNavLinks.length === 0) {
    return;
  }

  // Jumpto Links
  Array.from(jumptoNavLinks).forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      const linkName = event.target.getAttribute('href');
      const section = document.getElementsByName(linkName.substring(1))[0];
      event.target.classList.add('current');
      if (window.innerWidth < 1281) {
        TweenLite.to(window, 0.6, { scrollTo: { y: section, offsetY: 50 + 86 } });
      } else {
        TweenLite.to(window, 0.6, { scrollTo: { y: section, offsetY: 50 + 46 } });
      }
    });
  });

  // Jumpto Highlighting
  Array.from(jumptoSections).forEach((element, idx) => {
    const section = document.getElementsByName(element.getAttribute('name'))[0];
    let distance = 140;

    // While Scrolling
    document.addEventListener('scroll', () => {
      const sectionDistanceToTop = section.nextElementSibling.getBoundingClientRect().top;
      const sectionLink = document.querySelectorAll(
        `.jumpto-sidebar a[href='#${section.getAttribute('name')}']`,
      );
      const sectionTitle = document.getElementById('guidesNav-title');
      if (window.innerWidth < 1281) {
        distance = 140 + 86;
      }

      if (idx === 0 && sectionDistanceToTop > distance) {
        // If above the first section change title to page
        Array.from(jumptoNavLinks).forEach(links => {
          links.classList.remove('current');
        });
        sectionTitle.innerHTML = `Find it fast`;
      } else if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        // If at the bottom of the page highlight last item
        Array.from(jumptoNavLinks).forEach((links, index, array) => {
          if (index === array.length - 1) {
            links.classList.add('current');
            sectionTitle.innerHTML = `Find it fast / ${section.childNodes[0].innerHTML}`;
          } else {
            links.classList.remove('current');
          }
        });
      } else if (sectionDistanceToTop < distance) {
        // Highlight item if smaller than distance from top
        Array.from(jumptoNavLinks).forEach(links => {
          links.classList.remove('current');
        });
        if (sectionLink[0]) {
          sectionLink[0].classList.add('current');
        }
        sectionTitle.innerHTML = `Find it fast / ${section.childNodes[0].innerHTML}`;
      } else if (sectionDistanceToTop > distance) {
        // Unhighlight item if greater than distance from top
        if (sectionLink[0]) {
          sectionLink[0].classList.remove('current');
        }
      }
    });
  });
});
